// F4 Report 1: Assigned to Site Marking
import React, { useEffect, useState } from "react";
import { fetchReportSiteMarking } from "../../api/service";
import ReportShell, { display, downloadReportCsv } from "./ReportShell";

const SiteMarkingReport = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchReportSiteMarking()
      .then((res) => {
        if (!alive) return;
        setRows(res?.rows || []);
        setCount(res?.count || 0);
      })
      .catch((e) => alive && setError(e?.message || "Failed to load"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <ReportShell
      title="1. Assigned to Site Marking"
      count={count}
      loading={loading}
      error={error}
      onExport={() => downloadReportCsv("site_marking")}
    >
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-center">Project</th>
              <th className="text-center">Civil Members</th>
              <th className="text-center">Ageing (days)</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={3} className="text-center text-muted py-4">No projects in this stage.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.project_id}>
                <td className="text-center">{r.project_label}</td>
                <td className="text-center">{display(r.civil_members)}</td>
                <td className="text-center">{display(r.ageing_days)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportShell>
  );
};

export default SiteMarkingReport;
